module.exports = __webpack_public_path__ + "media/images/backgrounds/background-feature-drills-vertical-22d3c57d0f4066449270e7429fb60cc3.svg";